module.exports = __webpack_public_path__ + "img/about_communication.ac5476f2.png";